import { StickyHeaderLinksBlockData } from 'api/cms';
import { AmpLinksBlock } from 'cms/blocks/Amp/AmpLinksBlock';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { StickyHeaderLinksBlock } from './StickyHeaderLinksBlock';

export const StickyHeaderLinksBlockMapping: BlockMapping<StickyHeaderLinksBlockData> =
  {
    invariant: [
      {
        prop: 'links',
        msg: 'Links required for sticky header links',
      },
    ],
    width: 'FULL',
    Component: StickyHeaderLinksBlock,
    AmpComponent: AmpLinksBlock,
  };
